import React from 'react';

const Revenue = () => {
    return (
        <div>
            <h1>Revenue Page</h1>
            <p>Welcome to the Revenue page. Here you can view and manage revenue details.</p>
        </div>
    );
};

export default Revenue; 